if (!customElements.get('product-variant-change-updater')) {
    customElements.define('product-variant-change-updater', class ProductVariantChangeUpdater extends HTMLElement {
        constructor() {
            super();
        }

        variantChangeSubscriber = undefined;

        connectedCallback() {
            this.variantChangeSubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              this.onProductVariantChange(event.data.html);
              this.onProductVariantChangeCompleted();
            });
        }
    
        disconnectedCallback() {
            if (this.variantChangeSubscriber) {
                this.variantChangeSubscriber();
            }
        }

        onProductVariantChange(html) {
            let element = html.getElementsByName(this.getAttribute("name"));
            if (element.length == 0) {
                return;
            }

            this.innerHTML = element[0].innerHTML;
        }

        onProductVariantChangeCompleted() {
            publish("variant-change-update-completed", { source: 'product-variant-change-updater', name: this.getAttribute("name") });
        }
    });
}